import React from 'react';

import { RoundedDecrement, RoundedIncrement } from '@travel/icons/ui';
import type { useNumberIncrementHandler } from '@travel/traveler-core/components/AmountInput/hooks';
import { useDeviceType, MOBILE_SCREEN } from '@travel/traveler-core/hooks';

import PersonInput from './PersonInput';
import RoomInput from './RoomInput';

import styles from './amountInput.module.scss';

type AmountInputContentProps = {
  className?: string;
  adults: ReturnType<typeof useNumberIncrementHandler>;
  childrenUpperGrade: ReturnType<typeof useNumberIncrementHandler>;
  childrenLowerGrade: ReturnType<typeof useNumberIncrementHandler>;
  infantsBedMeal: ReturnType<typeof useNumberIncrementHandler>;
  infantsBed: ReturnType<typeof useNumberIncrementHandler>;
  infantsMeal: ReturnType<typeof useNumberIncrementHandler>;
  infantsNone: ReturnType<typeof useNumberIncrementHandler>;
  rooms: ReturnType<typeof useNumberIncrementHandler>;
  isDomestic: boolean;
};

export function AmountInputContent(props: AmountInputContentProps) {
  const {
    className,
    adults,
    childrenUpperGrade,
    childrenLowerGrade,
    infantsBedMeal,
    infantsBed,
    infantsMeal,
    infantsNone,
    rooms,
    isDomestic,
  } = props;
  const isSP = useDeviceType() === MOBILE_SCREEN;

  const decrementIcon = <RoundedDecrement size={32} />;
  const incrementIcon = <RoundedIncrement size={32} />;

  const roomContent = (
    <RoomInput rooms={rooms} incrementIcon={incrementIcon} decrementIcon={decrementIcon} />
  );

  const personContent = (
    <PersonInput
      adults={adults}
      childrenUpperGrade={childrenUpperGrade}
      childrenLowerGrade={childrenLowerGrade}
      infantsBedMeal={infantsBedMeal}
      infantsBed={infantsBed}
      infantsMeal={infantsMeal}
      infantsNone={infantsNone}
      incrementIcon={incrementIcon}
      decrementIcon={decrementIcon}
      isDomestic={isDomestic}
    />
  );

  return (
    <div className={className} data-testid="amountInput-content-container">
      <div className={styles.contentWrapper}>
        {!isSP ? (
          <>
            <div className={styles.room}>{roomContent}</div>
            <div>{personContent}</div>
          </>
        ) : (
          <>
            {personContent}
            <div className={styles.separator} />
            {roomContent}
          </>
        )}
      </div>
    </div>
  );
}
export default AmountInputContent;
